import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_COUPONS = SERVER_URI + '/coupon';
const GET_COUPONS = SERVER_URI + '/get-coupon';
const UPDATE_COUPON_DATA = SERVER_URI + '/coupon/';
const COUPON_STATUS = SERVER_URI + '/coupon-status/';




export default {
  addCoupons: async function (paylaod) {
    console.log("discount payload", paylaod)
    return apiPost(ADD_COUPONS, paylaod)
  },
  getCoupons: async function (payload) {
    console.log('pay', payload);
    return apiPost(GET_COUPONS, payload);
  },
  CouponStatus: async function (id) {
    return apiGet(COUPON_STATUS + id);
  },
  updateCouponData: async function (id, payload) {
    console.log("immd.....", id, payload)
    return apiPut(UPDATE_COUPON_DATA + id, payload)
  }
}